import { useLayoutEffect } from 'react';

function upsertMetaName(name, content) {
  if (content == null || content === '') return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertMetaProperty(property, content) {
  if (content == null || content === '') return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLinkCanonical(href) {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Syncs document title and meta tags from CMS `seo` (client-side).
 * Static `index.html` keeps minimal fallbacks for first paint and non-JS crawlers.
 */
export default function DocumentHead({ seo }) {
  useLayoutEffect(() => {
    if (!seo || typeof seo !== 'object') return;

    document.title = seo.htmlTitle || '';

    upsertMetaName('description', seo.description);
    upsertMetaName('keywords', seo.keywords);
    upsertMetaName('author', seo.author);
    upsertMetaName('robots', seo.robots);
    upsertMetaName('theme-color', seo.themeColor);
    upsertMetaName('apple-mobile-web-app-title', seo.siteName);

    upsertMetaProperty('og:type', 'website');
    upsertMetaProperty('og:site_name', seo.siteName);
    upsertMetaProperty('og:title', seo.socialTitle);
    upsertMetaProperty('og:description', seo.socialDescription);
    upsertMetaProperty('og:image', seo.shareImageUrl);
    upsertMetaProperty('og:image:alt', seo.shareImageAlt);
    upsertMetaProperty('og:locale', seo.ogLocale);

    const canonical =
      seo.canonicalUrl ||
      (typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : '');
    if (canonical) {
      upsertLinkCanonical(canonical);
      upsertMetaProperty('og:url', canonical);
    }

    upsertMetaName('twitter:card', 'summary_large_image');
    upsertMetaName('twitter:title', seo.socialTitle);
    upsertMetaName('twitter:description', seo.socialDescription);
    upsertMetaName('twitter:image', seo.shareImageUrl);
    upsertMetaName('twitter:image:alt', seo.shareImageAlt);
  }, [seo]);

  return null;
}
